"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var EmptyState = function EmptyState(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    fill: "none",
    height: size,
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#EmptyStateId)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M86.121 89.223H29.497a6.386 6.386 0 0 1-6.392-6.392V31.806a6.386 6.386 0 0 1 6.392-6.392H86.12a6.386 6.386 0 0 1 6.393 6.392v53.457"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M76.392 79.324 91.24 94.173a3.603 3.603 0 0 0 5.147-.057 3.594 3.594 0 0 0-.056-5.034l-14.85-14.85M23.105 41.084h69.409"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M33.004 35.936a2.46 2.46 0 1 0 0-4.922 2.46 2.46 0 0 0 0 4.922ZM40.895 35.936a2.46 2.46 0 1 0 0-4.922 2.46 2.46 0 0 0 0 4.922ZM48.786 35.936a2.46 2.46 0 1 0 0-4.922 2.46 2.46 0 0 0 0 4.922Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M66.35 82.124c9.717 0 17.594-7.877 17.594-17.593 0-9.716-7.877-17.593-17.593-17.593-9.716 0-17.593 7.877-17.593 17.593 0 9.716 7.877 17.593 17.593 17.593ZM72.602 58.592l-11.823 11.85M60.779 58.592l11.823 11.85"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "EmptyStateId"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.69 24h77.102v72.605H21.69z"
  }))));
};
var _default = exports["default"] = EmptyState;